export const FONT_STACK =
  "'CircularSTDBook', 'Inter', system-ui, sans-serif";

/** Shared L/R page gutter for list/add/edit/detail on larger screens.
 *  Always 0 — layout `.qv-main-offset` already pads the shell. */
export const PO_PAGE_PAD_X_CSS = "0px";
/** Inner L/R padding for PO cards, tables, and sidebars on larger screens. */
export const PO_PAD_X = "clamp(12px, 2.2vw, 18px)";

export const PO_LIST_PAD_X_CSS = PO_PAGE_PAD_X_CSS;
export const PO_LIST_CARD_PAD_X_CSS = PO_PAD_X;
export const PO_LIST_TABLE_PAD_X_CSS = "clamp(10px, 2vw, 16px)";

/** Page L/R gutter. Always 0 — layout `.qv-main-offset` already pads the shell. */
export const poPagePadX = () => "0px";
/** Inner card/table L/R padding on mobile, where the shell gutter is already tight. */
export const PO_MOBILE_PAD_X = "12px";
/** Inner card/table L/R padding, so content never touches a card's border. */
export const poContentPadX = (isMobile) => (isMobile ? PO_MOBILE_PAD_X : PO_PAD_X);

export const poMobileFieldLabelStyle = {
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: 0.35,
  textTransform: "uppercase",
  color: "var(--qv-tx-7a818f, #7a818f)",
  marginBottom: 4,
};

export const PO_STATUS_META = {
  draft: { label: "Draft", color: "var(--qv-tx-7a818f, #7a818f)", bg: "rgba(122,129,143,0.12)" },
  sent: { label: "Active", color: "var(--qv-brand-text)", bg: "var(--qv-brand-soft)" },
  partial: { label: "Partial", color: "var(--qv-tx-a14a00, #a14a00)", bg: "rgba(232,89,12,0.10)" },
  received: { label: "Received", color: "var(--qv-tx-0a7c4a, #0a7c4a)", bg: "rgba(10,124,74,0.10)" },
  cancelled: { label: "Cancelled", color: "var(--qv-tx-c92a2a, #c92a2a)", bg: "rgba(201,42,42,0.08)" },
};

export const STATUS_FILTER_TABS = [
  { id: "all", label: "All" },
  { id: "draft", label: "Draft" },
  { id: "sent", label: "Active" },
  { id: "partial", label: "Partial" },
  { id: "received", label: "Received" },
  { id: "cancelled", label: "Cancelled" },
];

/** List API `sort_col` values (column header sorting). */
export const LIST_SORT_COLS = {
  poId: "po_id",
  date: "date",
  amount: "amt",
  vendor: "vendor",
};

export const DEFAULT_LIST_SORT = {
  col: LIST_SORT_COLS.poId,
  ord: "desc",
};

/** UI status tab id → API `search_filters` (blank = all). */
export const STATUS_FILTER_API = {
  sent: "0",
  partial: "1",
  received: "2",
  cancelled: "3",
  draft: "4",
};

export const SEARCH_DEBOUNCE_MS = 500;

/** Vendor filter sentinel — maps to API `search_by_vendor=no_vendor`. */
export const VENDOR_FILTER_NO_VENDOR = "no_vendor";

/** Rows per page for `new_purchase_orders_list` (page + per_page). */
export const PO_LIST_PER_PAGE = 100;

/** Vendors per page for `new_purchase_orders_vendor_list` (scroll pagination). */
export const PO_VENDOR_LIST_PER_PAGE = 50;

/** Categories per page for product-picker filter (`Categoryapi/category_list`). */
export const PO_CATEGORY_LIST_PER_PAGE = 50;

/** Products per page for product picker (`new_purchase_orders_product_list_v2`). */
export const PO_PRODUCT_LIST_PER_PAGE = 100;

/** Distance from bottom of scroll container to trigger next page load. */
export const PO_LIST_SCROLL_LOAD_THRESHOLD_PX = 200;

export const INTRO_BANNER_STORAGE_KEY = "po-new-intro-dismissed-v2";

export const TABLE_GRID_COLUMNS =
  "minmax(120px,1fr) minmax(140px,1.4fr) minmax(90px,0.8fr) minmax(100px,1.1fr) minmax(100px,1fr) minmax(90px,1fr)";
